exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".case-detail-title[data-v-8c53c60c]{font-weight:bolder;font-size:20px;color:#2d8cf0;margin-bottom:24px}.case-detail-form-item[data-v-8c53c60c]{width:100%;display:inline-block;padding-right:2%}.case-detail-material-li[data-v-8c53c60c]{display:inline-block;margin:12px;float:left}.case-detail-material-img[data-v-8c53c60c]{width:80px;height:80px;border:2px solid #42c2f3}.case-detail-clear[data-v-8c53c60c]{clear:both}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8c53c60c","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--1-1!./src/components/case/caseManager/caseDetail/Slide.vue
// module id = Wexd
// module chunks = 2